var map = {
	"./bling.png": "15c9",
	"./citel.png": "97d1",
	"./clear-sale.png": "8d15",
	"./google-shopping.png": "fb7c",
	"./iugu.png": "4863",
	"./melhor-envio.png": "7836",
	"./mercado-livre.png": "c106",
	"./meta.png": "afe6",
	"./totvs-winthor.png": "a569",
	"./whatsapp.png": "044f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ee8";